import React, { useState, useEffect } from 'react';
import './Home.css';
import LogoSecundario from '../../assets/FamiliaSingularSecundaria.svg';
import LogoEscrita from '../../assets/FamiliaSingularLogoEscrita.svg';
import '../NossosProfissionais/NossosProfissionais.css';
import NossosProfissionais from '../NossosProfissionais/NossosProfissionais';
import '../NossoEspaco/NossoEspaco.css';
import NossoEspaco from '../NossoEspaco/NossoEspaco';
import '../Sobre/Sobre.css';
import Sobre from '../Sobre/Sobre';
import '../Contato/Contato.css';
import Contato from '../Contato/Contato';
import "../../components/Footer/Footer.css";
import Footer from "../../components/Footer/Footer";
import Instrucoes from '../../components/Instrucoes/Instrucoes';
import '../../../src/styles/mediaqueries.css';
import Servicos from '../Servicos/Servicos';
import '../Servicos/Servicos.css';
import Oficina from '../Oficina/Oficina';

function Home() {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [showArrow, setShowArrow] = useState(true);

  const scrollToNextSection = () => {
    const nextSection = document.getElementById('sobre');
    if (nextSection) {
      nextSection.scrollIntoView({ behavior: 'smooth' });
    }
  };    

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    const handleScroll = () => {
      if (window.scrollY > 50) {
        setShowArrow(false);
      } else {
        setShowArrow(true);
      }
    };

    window.addEventListener('resize', handleResize);
    window.addEventListener('scroll', handleScroll);
  
    return () => {
      window.removeEventListener('resize', handleResize);
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const logoAtual = isMobile ? LogoEscrita : LogoSecundario;

  return (
    <div>
      <Instrucoes />
      <section id="home" className="section">
        <div className="container">
          <img src={logoAtual} alt="Logo" className="logo" id="logo" />
          <div className={`scrollDown ${showArrow ? '' : 'fade-out'}`} id="scrollDownArrow">
            <button
              id='next-section'
              className='arrow-button material-symbols-rounded'
              onClick={scrollToNextSection}
            >
              expand_more
            </button>
          </div>
        </div>
      </section>

      <section id="sobre" className="section section-sobre">
        <div className="container">
          <Sobre />
          <Oficina />
        </div>
      </section>

      <section id="servicos" className="section">
        <div className="container">
          <Servicos />
        </div>
      </section>

      <section id="profissionais" className="section">
        <div className="container">
          <NossosProfissionais />
        </div>
      </section>

      <section id="espaco" className="section-espaco">
        <div className="container">
          <NossoEspaco />
        </div>
      </section>

      <section id="contato" className="section">
        <div className="container">
          <Contato />
        </div>
      </section>

      <section id="footer" className="section">
        <div className="container">
          <Footer />
        </div>
      </section>
    </div>
  );
}

export default Home;
